(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amra-aroma"]) return;
  try {
    
  document.querySelectorAll('[data-amra-aroma]').forEach((root) => {
    // Mikro-Animation nur, wenn die Sektion im Bild ist (spart Akku,
    // startet die Loops erst beim Erreichen der Karten).
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((eintraege) => {
        root.classList.toggle('amra-aroma--wach', eintraege[0].isIntersecting);
      }, { threshold: 0.15 }).observe(root);
    } else {
      root.classList.add('amra-aroma--wach');
    }

    const track = root.querySelector('[data-amra-aroma-track]');
    const prev = root.querySelector('[data-amra-aroma-prev]');
    const next = root.querySelector('[data-amra-aroma-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const card = track.querySelector('.amra-aroma__card');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || '0');
      return card.getBoundingClientRect().width + gap;
    };

    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-cart-drawer"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-amra-cart]');
    if (!root || root.dataset.amraBound) return;
    root.dataset.amraBound = 'true';

    const open = () => {
      root.classList.add('amra-cart--open');
      document.documentElement.style.setProperty('--amra-cart-open', '1');
    };
    const close = () => root.classList.remove('amra-cart--open');

    // Geschenk automatisch legen und wieder entfernen.
    let geschenkLaeuft = false;
    const geschenkPruefen = async () => {
      const variante = Number(root.dataset.amraGiftVariant || 0);
      const schwelle = Number(root.dataset.amraGiftThreshold || 0);
      if (!variante || !schwelle || geschenkLaeuft) return false;
      geschenkLaeuft = true;
      try {
        const korb = await (await fetch('/cart.js')).json();
        const zeile = korb.items.find((i) => i.variant_id === variante);
        // Der Warenkorbwert wird OHNE das Geschenk gemessen, sonst haelt sich
        // das Geschenk am Ende selbst ueber der Schwelle.
        const ohneGeschenk = korb.original_total_price - (zeile ? zeile.original_line_price : 0);

        if (ohneGeschenk >= schwelle && !zeile) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variante, quantity: 1 }] }),
          });
          return true;
        }
        if (ohneGeschenk < schwelle && zeile) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: zeile.key, quantity: 0 }),
          });
          return true;
        }
        return false;
      } catch (e) {
        return false;
      } finally {
        geschenkLaeuft = false;
      }
    };

    const rerender = async (thenOpen) => {
      // Erst pruefen, ob das Geschenk rein oder raus muss, dann zeichnen —
      // sonst sieht der Kunde fuer einen Moment den Zwischenstand.
      await geschenkPruefen();
      try {
        const res = await fetch(window.location.pathname + '?sections=amra-cart-drawer');
        const data = await res.json();
        const html = data['amra-cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-amra-cart] .amra-cart__panel');
        const current = root.querySelector('.amra-cart__panel');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        const count = root.querySelector('[data-amra-cart-count]');
        if (count) {
          document.querySelectorAll('.amra-header__count').forEach((el) => {
            el.textContent = count.textContent;
          });
        }
        if (thenOpen) open();
      } catch (e) {
        if (thenOpen) open();
      }
    };



    let busy = false;
    const queue = [];
    const pending = new Map();
    const flush = async () => {
      if (busy) return;
      const job = queue.shift();
      if (!job) return;
      busy = true;
      root.classList.add('amra-cart--busy');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(job),
        });
        if (!res.ok) queue.length = 0;
      } catch (e) {
        queue.length = 0;
      }
      await rerender(false);
      if (queue.length === 0) pending.clear();
      busy = false;
      root.classList.remove('amra-cart--busy');
      flush();
    };
    const enqueue = (job) => {
      const existing = queue.findIndex((j) => j.id === job.id);
      if (existing > -1) queue[existing] = job;
      else queue.push(job);
      flush();
    };

    // Der 5+1-Rabatt teilt eine Position in mehrere Zeilen. Eine einzelne davon
    // zu aendern ergibt Unsinn — deshalb alle Zeilen der Gruppe leeren und die
    // neue Gesamtmenge einmal frisch hinzufuegen. Welche Rabatte dann greifen,
    // entscheidet Shopify; unser Code muss die Aktionsregeln nicht kennen.
    const gruppeSetzen = async (daten, ziel) => {
      const keys = (daten.amraKeys || '').split(',').filter(Boolean);
      if (keys.length === 0) return;
      const leeren = {};
      keys.forEach((k) => { leeren[k] = 0; });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: leeren }),
      });
      if (ziel > 0) {
        const eintrag = { id: Number(daten.amraVariant), quantity: ziel };
        if (daten.amraPlan) eintrag.selling_plan = Number(daten.amraPlan);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [eintrag] }),
        });
      }
      await rerender(false);
    };

    document.addEventListener('click', async (event) => {
      const opener = event.target.closest('[data-amra-cart-open]');
      if (opener) {
        event.preventDefault();
        await rerender(true);
        return;
      }
      if (event.target.closest('[data-amra-cart-close]') || event.target.closest('[data-amra-cart-close-target]')) {
        close();
        return;
      }
      const qty = event.target.closest('[data-amra-qty-delta]');
      if (qty && root.contains(qty)) {
        const schritt = parseInt(qty.dataset.amraStep, 10) || 1;
        const minimum = parseInt(qty.dataset.amraMin, 10) || 1;
        const richtung = parseInt(qty.dataset.amraQtyDelta, 10);
        const jetzt = parseInt(qty.dataset.amraCurrent, 10);

        // Auf das naechste Vielfache rasten, nicht stumpf addieren.
        let ziel;
        if (richtung > 0) {
          ziel = Math.floor(jetzt / schritt) * schritt + schritt;
        } else {
          ziel = Math.ceil(jetzt / schritt) * schritt - schritt;
        }

        // Unter die Mindestmenge geht es per Minus nicht: die Position bleibt,
        // stattdessen erscheint der Hinweis (Ansage Noel). Entfernen laeuft
        // ausschliesslich ueber den Entfernen-Knopf daneben.
        if (richtung < 0 && minimum > 1 && ziel < minimum) {
          const item = qty.closest('.amra-cart__item');
          const hint = item && item.querySelector('[data-amra-min-hint]');
          if (hint) {
            hint.textContent = hint.dataset.amraMinText;
            clearTimeout(hint.amraTimer);
            hint.amraTimer = setTimeout(() => { hint.textContent = ''; }, 4000);
          }
          return;
        }
        if (ziel < minimum) ziel = 0;

        await gruppeSetzen(qty.dataset, ziel);
        return;
      }
      const rm = event.target.closest('[data-amra-remove]');
      if (rm && root.contains(rm)) {
        await gruppeSetzen(rm.dataset, 0);
        return;
      }
      const ab = event.target.closest('[data-amra-abo-switch]');
      if (ab && root.contains(ab) && !ab.disabled) {
        // Kaufart wechseln: gleiche Gruppen-Logik, nur mit/ohne selling_plan.
        const menge = parseInt(ab.dataset.amraQty, 10) || 0;
        await gruppeSetzen({
          amraKeys: ab.dataset.amraKeys,
          amraVariant: ab.dataset.amraVariant,
          amraPlan: ab.dataset.amraPlanTarget,
        }, menge);
        return;
      }
      const up = event.target.closest('[data-amra-upsell]');
      if (up && root.contains(up)) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(up.dataset.amraUpsell), quantity: 1 }),
        });
        await rerender(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('amra:cart:refresh', (event) => {
      rerender(event.detail && event.detail.open);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-cart-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const wurzel = document.querySelector('.amra-cartpage');
    if (!wurzel) return;

    // Gleiche Logik wie in der Schublade: alle Zeilen der Gruppe leeren, dann
    // die neue Gesamtmenge frisch hinzufuegen. Shopify entscheidet, welche
    // Rabatte greifen — der 5+1 spaltet die Position sonst in mehrere Zeilen.
    const gruppeSetzen = async (daten, ziel) => {
      const keys = (daten.amraKeys || '').split(',').filter(Boolean);
      if (!keys.length) return;
      const leeren = {};
      keys.forEach((k) => { leeren[k] = 0; });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: leeren }),
      });
      if (ziel > 0) {
        const eintrag = { id: Number(daten.amraVariant), quantity: ziel };
        if (daten.amraPlan) eintrag.selling_plan = Number(daten.amraPlan);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [eintrag] }),
        });
      }
      window.location.reload();
    };

    wurzel.querySelectorAll('[data-amra-qty-delta]').forEach((knopf) => {
      knopf.addEventListener('click', () => {
        const schritt = parseInt(knopf.dataset.amraStep, 10) || 1;
        const minimum = parseInt(knopf.dataset.amraMin, 10) || 1;
        const richtung = parseInt(knopf.dataset.amraQtyDelta, 10);
        const jetzt = parseInt(knopf.dataset.amraCurrent, 10);

        // Auf das naechste Vielfache rasten, nicht stumpf addieren.
        let ziel;
        if (richtung > 0) {
          ziel = Math.floor(jetzt / schritt) * schritt + schritt;
        } else {
          ziel = Math.ceil(jetzt / schritt) * schritt - schritt;
        }

        // Unter die Mindestmenge fuehrt der Stepper nicht: Position bleibt,
        // Hinweis erscheint (Ansage Noel). Entfernen nur ueber den Link.
        if (richtung < 0 && minimum > 1 && ziel < minimum) {
          const zeile = knopf.closest('.amra-cartpage__item');
          const hint = zeile && zeile.querySelector('[data-amra-min-hint]');
          if (hint) {
            hint.textContent = hint.dataset.amraMinText;
            clearTimeout(hint.amraTimer);
            hint.amraTimer = setTimeout(() => { hint.textContent = ''; }, 4000);
          }
          return;
        }
        if (ziel < minimum) ziel = 0;
        gruppeSetzen(knopf.dataset, ziel);
      });
    });

    wurzel.querySelectorAll('[data-amra-gruppe-remove]').forEach((knopf) => {
      knopf.addEventListener('click', () => gruppeSetzen(knopf.dataset, 0));
    });

    wurzel.querySelectorAll('[data-amra-abo-switch]').forEach((knopf) => {
      knopf.addEventListener('click', () => {
        if (knopf.disabled) return;
        // Kaufart wechseln: gleiche Gruppen-Logik, nur mit/ohne selling_plan.
        gruppeSetzen({
          amraKeys: knopf.dataset.amraKeys,
          amraVariant: knopf.dataset.amraVariant,
          amraPlan: knopf.dataset.amraPlanTarget,
        }, parseInt(knopf.dataset.amraQty, 10) || 0);
      });
    });

    wurzel.querySelectorAll('[data-amra-upsell-add]').forEach((knopf) => {
      knopf.addEventListener('click', async () => {
        knopf.disabled = true;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(knopf.dataset.amraVariant), quantity: Number(knopf.dataset.amraQty) || 1 }] }),
        });
        window.location.reload();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-collection"]) return;
  try {
    
  document.querySelectorAll('[data-amra-collection]').forEach((root) => {
    const toggle = root.querySelector('[data-amra-filter-toggle]');
    const panel = toggle && root.querySelector('#' + toggle.getAttribute('aria-controls'));
    const counter = root.querySelector('[data-amra-filter-count]');
    const filters = root.querySelectorAll('[data-amra-filter]');
    const items = root.querySelectorAll('[data-amra-item]');
    const empty = root.querySelector('[data-amra-empty]');

    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    }

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        const active = btn.dataset.amraFilter;
        filters.forEach((b) => b.classList.toggle('amra-collection__filter--active', b === btn));
        let visible = 0;
        items.forEach((item) => {
          const tags = (item.dataset.amraTags || '').split(/\s+/);
          const show = active === 'alle' || tags.includes(active);
          item.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
        if (counter) counter.textContent = active === 'alle' ? '(0)' : '(1)';
      });
    });

    root.addEventListener('click', async (event) => {
      const add = event.target.closest('[data-amra-add]');
      if (!add) return;
      event.preventDefault();
      add.setAttribute('aria-busy', 'true');
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // Wein wird in Gebinden verkauft. Eine einzelne Flasche wuerde die
          // Dreierschrittweite im Warenkorb sofort unterlaufen — und Shopify
          // legt sie wegen abweichender Rabattzuordnung als eigene Zeile an,
          // sodass derselbe Wein dreimal untereinander steht.
          body: JSON.stringify({
            id: Number(add.dataset.amraAdd),
            quantity: Number(add.dataset.amraQty) || 1,
          }),
        });
        document.dispatchEvent(new CustomEvent('amra:cart:refresh', { detail: { open: true } }));
      } finally {
        add.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-craft-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-amra-craft]');
    if (!wurzel) return;
    wurzel.classList.add('amra-craft--js');

    const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const szenen = [...wurzel.querySelectorAll('[data-craft-szene]')];

    // --- Frame-Sequenzen: laden erst, wenn die Szene naht (14 MB gesamt) ---
    let quellen = {};
    const datenEl = wurzel.querySelector('[data-craft-frames]');
    if (datenEl) {
      try { quellen = JSON.parse(datenEl.textContent); } catch (fehler) { quellen = {}; }
    }

    // Handys (< 750px) bekommen den schmalen Mittenausschnitt-Satz.
    const mobil = window.matchMedia('(max-width: 749px)').matches;
    const filme = [...wurzel.querySelectorAll('[data-craft-film]')].map((leinwand) => {
      const name = leinwand.getAttribute('data-craft-film');
      const urls = (mobil && quellen[name + '-m']) || quellen[name] || [];
      return {
        leinwand,
        szene: leinwand.closest('[data-craft-szene]'),
        urls,
        bilder: null
      };
    });

    // Laden in Reihenfolge, hoechstens 4 gleichzeitig. Vorher gingen alle 48
    // Requests auf einmal raus; ueber HTTP/2 teilten sie sich die Bandbreite,
    // und bei langsamer Verbindung war der erste fertige Frame ein
    // zufaelliger aus der Mitte (gemessen 11.09., Slow 4G). Der gerade
    // gewuenschte Frame darf sich vordraengeln (Reload mitten auf der Seite).
    const PARALLEL = 4;
    const naechste = (film) => {
      while (film.laufend < PARALLEL && film.warte.length) starte(film, film.warte.shift());
    };
    const starte = (film, i) => {
      const bild = film.bilder[i];
      film.laufend++;
      const fertig = () => {
        film.laufend--;
        naechste(film);
        // Vor-Dekodieren abseits des Hauptthreads: der erste drawImage eines
        // Frames dekodiert sonst synchron mitten im Scroll (Ruckler).
        // Jeder fertige Frame stoesst den rAF-gedrosselten Takt an — so
        // landet auch ein spaet eintreffender Wunsch-Frame ohne Scroll-Event.
        if (bild.naturalWidth && bild.decode) {
          bild.decode().catch(() => {}).then(tick);
        } else {
          tick();
        }
      };
      bild.onload = fertig;
      bild.onerror = fertig;
      if (i < 2) bild.fetchPriority = 'high';
      bild.src = film.quellen[i];
    };
    const vordraengeln = (film, i) => {
      if (!film.warte) return;
      const k = film.warte.indexOf(i);
      if (k > 0) {
        film.warte.splice(k, 1);
        film.warte.unshift(i);
      }
    };

    const ladeFilm = (film) => {
      if (film.bilder || !film.urls.length) return;
      // Reduzierte Bewegung: ein einziger, mittlerer Frame statt 48.
      film.quellen = ruhig ? [film.urls[Math.floor(film.urls.length / 2)]] : film.urls;
      film.bilder = film.quellen.map(() => {
        const bild = new Image();
        bild.decoding = 'async';
        return bild;
      });
      film.warte = film.quellen.map((url, i) => i);
      film.laufend = 0;
      naechste(film);
    };

    const fortschritt = (szene, puffer, spanne) => {
      const r = szene.getBoundingClientRect();
      const vh = window.innerHeight;
      const roh = Math.max(0, Math.min(1, -r.top / ((r.height - vh) || 1)));
      return Math.max(0, Math.min(1, (roh - puffer) / spanne));
    };

    const zeichneFilm = (film) => {
      const leinwand = film.leinwand;
      if (!film.bilder) return;
      const r = film.szene.getBoundingClientRect();
      const vh = window.innerHeight;
      // Nur zeichnen, wenn die Szene ueberhaupt in Sichtweite ist.
      if (r.bottom < -vh || r.top > vh * 2) return;
      const p = fortschritt(film.szene, 0.06, 0.88);
      const anzahl = film.bilder.length;
      const idx = ruhig ? Math.floor(anzahl / 2) : Math.max(0, Math.min(anzahl - 1, Math.round(p * (anzahl - 1))));
      const wunsch = film.bilder[idx];
      if (!wunsch.naturalWidth) vordraengeln(film, idx);
      const ersatz = film.bilder.slice(0, idx + 1).reverse().find((b) => b.complete && b.naturalWidth)
        || film.bilder.find((b) => b.complete && b.naturalWidth);
      const bild = (wunsch.complete && wunsch.naturalWidth) ? wunsch : ersatz;
      if (!bild) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      const b = Math.round(leinwand.clientWidth * dpr);
      const h = Math.round(leinwand.clientHeight * dpr);
      if (leinwand.width !== b || leinwand.height !== h) {
        leinwand.width = b;
        leinwand.height = h;
      }
      const ctx = leinwand.getContext('2d');
      const skala = Math.max(b / bild.naturalWidth, h / bild.naturalHeight);
      const zb = bild.naturalWidth * skala;
      const zh = bild.naturalHeight * skala;
      ctx.drawImage(bild, (b - zb) / 2, (h - zh) / 2, zb, zh);
    };

    // --- Tacho (Szene 3): 78 Grad fallen auf 30, Ease-out, Skala 20-90 ---
    const tachoflaeche = wurzel.querySelector('[data-craft-tachoflaeche]');
    const nadel = wurzel.querySelector('[data-craft-nadel]');
    const bogen = wurzel.querySelector('[data-craft-bogen]');
    const tempWert = wurzel.querySelector('[data-craft-temp]');
    let letzteTemp = null;

    const tacho = () => {
      if (!tachoflaeche || !nadel) return;
      const szene = tachoflaeche.closest('[data-craft-szene]');
      const p = ruhig ? 1 : fortschritt(szene, 0.12, 0.76);
      const ease = 1 - Math.pow(1 - p, 2);
      const temp = Math.round((78 - 48 * ease) * 10) / 10;
      if (temp === letzteTemp) return;
      letzteTemp = temp;
      tempWert.textContent = Math.round(temp) + '°';
      const anteil = (temp - 20) / 70;
      bogen.setAttribute('stroke-dasharray', (anteil * 100).toFixed(1) + ' 100');
      nadel.setAttribute('transform', 'rotate(' + (-120 + 240 * anteil).toFixed(1) + ' 150 150)');
      const kuehle = 1 - Math.max(0, Math.min(1, (temp - 30) / 48));
      const grau = Math.round(kuehle * 44);
      tachoflaeche.style.background = 'rgb(' + grau + ',' + grau + ',' + grau + ')';
    };

    // --- Textblenden: Szene gilt als da, wenn sie die Viewport-Mitte kreuzt ---
    const blende = () => {
      const vh = window.innerHeight;
      szenen.forEach((szene, i) => {
        const text = szene.querySelector('[data-craft-blende]');
        if (!text) return;
        const r = szene.getBoundingClientRect();
        // Das Register (letzte Szene) ist keine sticky Buehne, sondern fliesst
        // normal: sein Inhalt muss sichtbar sein, sobald es ins Bild kommt —
        // sonst steht auf grossen Bildschirmen ein leeres weisses Band mit
        // "05", bis 70 % der Hoehe erreicht sind (Michi 14.09.).
        const letzte = i === szenen.length - 1;
        const da = i === 0 || (letzte ? r.top <= vh * 0.96 : (r.top <= vh * 0.7 && r.bottom >= vh * 0.4));
        text.classList.toggle('ist-da', da);
      });
    };

    // --- Ein rAF-getakteter Takt fuer alles ---
    let takt = null;
    const tick = () => {
      if (takt) return;
      takt = requestAnimationFrame(() => {
        takt = null;
        const vh = window.innerHeight;
        // Naechste Szene zuerst anstossen (Reihenfolge der Requests
        // entscheidet, was der Browser zuerst bedient — wichtig bei
        // Reload/Back mitten auf der Seite).
        const abstand = (r) => (r.top > 0 ? r.top : Math.max(0, vh - r.bottom));
        filme
          .map((film) => ({ film, r: film.szene.getBoundingClientRect() }))
          .sort((a, b) => abstand(a.r) - abstand(b.r))
          .forEach(({ film, r }) => {
            if (r.top < vh * 4 && r.bottom > -vh) ladeFilm(film);
            zeichneFilm(film);
          });
        tacho();
        blende();
      });
    };

    // Horizon scrollt unter 990px im Dokument, ab 990px in .page-wrapper —
    // capture am Dokument sieht beide.
    document.addEventListener('scroll', tick, { capture: true, passive: true });
    window.addEventListener('resize', tick);
    window.addEventListener('pageshow', tick);
    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-footer"]) return;
  try {
    
  document.querySelectorAll('[data-amra-footer-newsletter]').forEach((form) => {
    const note = form.querySelector('[data-amra-footer-note]');
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button');
    const say = (text) => { if (note) { note.textContent = text; note.hidden = false; } };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const company = form.dataset.company;
      const list = form.dataset.list;
      const email = (input.value || '').trim();
      if (!email) return;
      if (!company || !list) {
        say(form.dataset.textUnconfigured);
        return;
      }
      button.disabled = true;
      try {
        const res = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            // Revision NICHT willkuerlich zurueckdrehen: erst ab 2025 nimmt dieser
            // Endpunkt 'subscriptions' im Profil an. Mit 2024-10-15 antwortet er 400,
            // und jede Anmeldung scheitert still.
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'AMRA Footer',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        // Standardfeld locale im BCP-47-Format (z. B. de-DE): Basis fuer
                        // Klaviyos abgeleitete "Locale: Language/Country", Segmente und
                        // Vorlagen. Die Ableitung laeuft aber asynchron — fuer den
                        // Welcome-Split braucht es deshalb zusaetzlich die schlichte
                        // Property "language", die sofort am Profil steht (10.09.).
                        locale: (form.dataset.lang || 'de') + '-' + (form.dataset.country || 'DE'),
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                        properties: {
                          language: form.dataset.lang || 'de',
                          signup_source: 'footer',
                        },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: list } } },
              },
            }),
          }
        );
        if (!res.ok && res.status !== 202) throw new Error('HTTP ' + res.status);
        form.reset();
        say(form.dataset.successText || form.dataset.textSuccess);
      } catch (err) {
        say(form.dataset.textError);
      } finally {
        button.disabled = false;
      }
    });
  });

  /* Cookie-Einstellungen wieder oeffnen. Pandectes' natives Reopen
     (#reopenBanner) ist eine Premium-Funktion — auf Plus loeschen wir
     stattdessen die gespeicherte Einwilligung und laden neu, dann fragt
     der Banner frisch. Erst wird der native Weg probiert: greift er
     (spaeteres Upgrade), bleibt die Entscheidung erhalten. */
  document.querySelectorAll('[data-amra-cookie-settings]').forEach((link) => {
    link.addEventListener('click', (ev) => {
      ev.preventDefault();
      window.location.hash = '#reopenBanner';
      window.setTimeout(() => {
        const cmp = document.querySelector('pandectes-cmp');
        const offen = cmp && cmp.shadowRoot && cmp.shadowRoot.querySelector('dialog');
        if (offen) return;
        const host = window.location.hostname.replace(/^www\./, '');
        document.cookie = '_pandectes_gdpr=; Max-Age=0; path=/';
        document.cookie = '_pandectes_gdpr=; Max-Age=0; path=/; domain=' + host;
        document.cookie = '_pandectes_gdpr=; Max-Age=0; path=/; domain=.' + host;
        window.location.reload();
      }, 450);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-garantie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-amra-garantie]');
    if (!form) return;

    const laden = form.querySelector('[data-g-laden]');
    const details = form.querySelector('[data-g-details]');
    const loadBtn = form.querySelector('[data-g-load]');
    const loadError = form.querySelector('[data-g-load-error]');
    const email = form.querySelector('[data-g-email]');
    const order = form.querySelector('[data-g-order]');

    const labelVon = (name) => form.querySelector('[data-g-label="' + name + '"]');
    const markiere = (name, fehlt) => {
      const l = labelVon(name);
      if (l) l.classList.toggle('amra-garantie__feldlabel--fehlt', fehlt);
    };

    // Stufe 1: erst mit E-Mail + Bestellnummer geht es weiter
    loadBtn.addEventListener('click', () => {
      const emailOk = email.value.trim() !== '' && email.checkValidity();
      const orderOk = order.value.trim() !== '';
      markiere('email', !emailOk);
      markiere('order', !orderOk);
      if (!emailOk || !orderOk) {
        loadError.hidden = false;
        return;
      }
      loadError.hidden = true;
      laden.hidden = true;
      details.hidden = false;
    });

    // Rücksende-Hinweis wechselt mit der Auswahl; Erstattungsnotiz nur bei Rücksendung
    const returnHint = form.querySelector('[data-g-return-hint]');
    const refundNote = form.querySelector('[data-g-refund-note]');
    const returnBoxes = [...form.querySelectorAll('[data-g-return]')];
    const returnUpdate = () => {
      const einige = returnBoxes.some((b) => b.checked);
      returnHint.textContent = einige ? returnHint.dataset.textSome : returnHint.dataset.textNone;
      refundNote.hidden = !einige;
    };
    returnBoxes.forEach((b) => b.addEventListener('change', returnUpdate));

    // Absenden: Pflichtfelder wie in der Vorlage rot markieren statt still scheitern.
    // Die Pruefung haengt am Button-KLICK, nicht am submit-Event — den faengt der
    // globale hCaptcha-Handler (amra-header) per stopImmediatePropagation vorher ab.
    const submitError = form.querySelector('[data-g-submit-error]');
    const pruefeVollstaendig = (e) => {
      const openedOk = [...form.querySelectorAll('[data-g-opened]')].some((r) => r.checked);
      const reason = form.querySelector('[data-g-reason]');
      const words = form.querySelector('[data-g-words]');
      const checks = [...form.querySelectorAll('[data-g-chk]')];
      const reasonOk = reason.value.trim() !== '';
      const wordsOk = words.value.trim() !== '';
      const checksOk = checks.every((c) => c.checked);

      markiere('opened', !openedOk);
      markiere('reason', !reasonOk);
      markiere('words', !wordsOk);
      checks.forEach((c) => c.closest('.amra-garantie__check').classList.toggle('amra-garantie__check--fehlt', !c.checked));

      if (!openedOk || !reasonOk || !wordsOk || !checksOk) {
        e.preventDefault();
        e.stopImmediatePropagation();
        submitError.hidden = false;
        return;
      }
      submitError.hidden = true;
    };
    const absenden = form.querySelector('button[type="submit"]');
    if (absenden) absenden.addEventListener('click', pruefeVollstaendig, { capture: true });
    form.addEventListener('submit', pruefeVollstaendig, { capture: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-header"]) return;
  try {
    
  document.querySelectorAll('[data-amra-menu]').forEach((menu) => {
    document.querySelectorAll('[data-amra-menu-open]').forEach((btn) => {
      btn.addEventListener('click', () => menu.showModal());
    });
    menu.querySelectorAll('[data-amra-menu-close]').forEach((btn) => {
      btn.addEventListener('click', () => menu.close());
    });
    menu.addEventListener('click', (event) => {
      if (event.target === menu) menu.close();
    });
  });

  // Sticky-Header: Announcement-Hoehe als CSS-Variable (0, wenn versteckt)
  // und Farbwechsel-Klasse ab kleiner Scrolltiefe. Horizon scrollt ab 990px
  // im .page-wrapper, darunter im Dokument — beide Quellen abhoeren.
  (() => {
    const kopf = document.querySelector('.amra-header');
    if (!kopf) return;
    const wrapper = document.querySelector('.page-wrapper');

    const messeLeiste = () => {
      const leiste = document.querySelector('.shopify-section-group-header-group .announcement-bar');
      const hoehe = leiste && leiste.offsetParent ? leiste.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--amra-announce-h', hoehe + 'px');
    };

    const scrollTiefe = () => Math.max(wrapper ? wrapper.scrollTop : 0, window.scrollY || 0);

    const aktualisiere = () => {
      kopf.classList.toggle('amra-header--stuck', scrollTiefe() > 40);
    };

    messeLeiste();
    aktualisiere();
    window.addEventListener('resize', messeLeiste);
    window.addEventListener('scroll', aktualisiere, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', aktualisiere, { passive: true });
  })();

  // Kontaktformulare + Spamschutz (gilt shopweit, Bundle laeuft ueberall):
  // Shopifys automatischer hCaptcha-Interceptor faengt den Submit ab,
  // schickt ihn aber nie wieder los — Formulare sterben still (Noels
  // Befund 28.08., in echten Browsern reproduziert). Deshalb rufen wir
  // protect() selbst und submitten im Callback nativ; form.submit()
  // feuert keine submit-Events und kann nicht erneut abgefangen werden.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/contact\b/.test(form.action)) return;
    if (form.dataset.amraCaptchaOk) return;
    const captcha = window.Shopify && window.Shopify.captcha;
    if (!captcha || typeof captcha.protect !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    captcha.protect(form, () => {
      form.dataset.amraCaptchaOk = '1';
      form.submit();
    });
  }, { capture: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-newsletter-popup"]) return;
  try {
    
  document.querySelectorAll('[data-amra-popup]').forEach((root) => {
    const panel = root.querySelector('.amra-popup__panel');
    const KEY_DISMISSED = 'amra-popup-dismissed';
    const KEY_DONE = 'amra-popup-done';
    const KEY_ZEIT = 'amra-popup-zeit'; /* sessionStorage: sichtbare Zeit der vorherigen Seiten (ms) */
    const KEY_GEZEIGT = 'amra-popup-gezeigt'; /* sessionStorage: hoechstens einmal pro Besuch */
    const days = parseInt(root.dataset.frequencyDays || '14', 10);
    const delay = parseInt(root.dataset.delay || '6', 10);
    const perZeit = root.dataset.triggerTime !== 'false';
    const perExit = root.dataset.exitIntent !== 'false' && window.matchMedia('(pointer: fine)').matches;
    const scrollPct = parseInt(root.dataset.scrollPercent || '0', 10) || 0;
    const params = new URLSearchParams(window.location.search);
    const force = params.has('amra-popup');
    const designMode = !!(window.Shopify && window.Shopify.designMode);
    let answer = '';
    let ausgeloest = false;
    let uhr = 0;

    const lies = (store, key) => {
      try {
        return window[store].getItem(key);
      } catch (e) {
        return null;
      }
    };
    const schreib = (store, key, wert) => {
      try {
        window[store].setItem(key, wert);
      } catch (e) {}
    };

    const show = () => {
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (!force && !designMode) schreib('sessionStorage', KEY_GEZEIGT, '1');
    };
    const hide = () => {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (!designMode) schreib('localStorage', KEY_DISMISSED, String(Date.now()));
    };
    const goto = (step) => {
      root.querySelectorAll('[data-amra-step]').forEach((el) => {
        el.hidden = el.dataset.amraStep !== String(step);
      });
      panel.setAttribute('data-amra-current-step', step);
    };

    /* Theme-Editor: Sektion anklicken zeigt das Popup sofort, kein Timer. */
    if (designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target && e.target.contains(root)) {
          goto(1);
          show();
        }
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.target && e.target.contains(root)) hide();
      });
    }

    /* Wer es nicht (mehr) sieht: bereits angemeldet, kuerzlich weggeklickt,
       in diesem Besuch schon gezeigt, oder aus einer Klaviyo-Mail gekommen
       (Tracking-Parameter _kx bzw. utm_source=klaviyo — die Person ist schon
       im Verteiler, das Popup waere nur im Weg). */
    const unterdrueckt = () => {
      if (lies('localStorage', KEY_DONE)) return true;
      const last = parseInt(lies('localStorage', KEY_DISMISSED) || '0', 10);
      if (last && Date.now() - last < days * 86400000) return true;
      if (lies('sessionStorage', KEY_GEZEIGT)) return true;
      if (params.has('_kx') || (params.get('utm_source') || '').toLowerCase() === 'klaviyo') {
        schreib('sessionStorage', KEY_GEZEIGT, 'mail');
        return true;
      }
      return false;
    };

    /* Besuchszeit = sichtbare Zeit ueber ALLE Seiten des Besuchs, nicht je
       Seite (Noel, 11.09.: mit 50 s Verzoegerung kam das Popup nie, weil
       jeder Seitenwechsel den Zaehler auf null setzte). Gezaehlt wird nur,
       solange der Tab im Vordergrund ist; der Stand wandert per
       sessionStorage von Seite zu Seite. */
    let vorher = parseInt(lies('sessionStorage', KEY_ZEIT) || '0', 10) || 0;
    let seit = document.visibilityState === 'hidden' ? 0 : Date.now();
    const besuchszeit = () => vorher + (seit ? Date.now() - seit : 0);
    const merkeZeit = () => schreib('sessionStorage', KEY_ZEIT, String(besuchszeit()));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        vorher = besuchszeit();
        seit = 0;
        merkeZeit();
      } else if (!seit) {
        seit = Date.now();
      }
    });
    window.addEventListener('pagehide', merkeZeit);

    /* Erst der Cookie-Banner, dann wir. Beides gleichzeitig sperrt auf dem
       Handy den halben Bildschirm und das Scrollen — der Kunde kommt weder
       an den Shop noch an das Formular.

       Gewartet wird auf die Consent-ENTSCHEIDUNG in Shopifys Customer
       Privacy API, nicht auf ein Banner-Element: Pandectes rendert in
       einem Shadow DOM, Shopifys eigener Banner in #shopify-pc__banner —
       die API ist der gemeinsame Nenner jedes CMP. Wer den Banner ewig
       ignoriert, sieht das Popup nicht; der Banner hat Vorrang. */
    const entscheidungOffen = () => {
      try {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || !cp.currentVisitorConsent) return false;
        if (cp.shouldShowBanner && !cp.shouldShowBanner()) return false;
        const c = cp.currentVisitorConsent();
        return !!c && c.marketing === '' && c.analytics === '';
      } catch (e) {
        return false;
      }
    };

    /* Die Privacy-API laedt asynchron. Feuert ein Ausloeser direkt beim
       Seitenstart (Besuchszeit schon voll, Exit-Intent), ist sie oft noch
       nicht da — dann kurz warten, statt "keine API" als "kein Banner" zu
       lesen. Bleibt sie laenger als 3 s aus, gibt es keinen Banner. */
    const apiFehlt = () => !(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.currentVisitorConsent);
    const zeigeWennFrei = () => {
      const t0 = Date.now();
      const bereit = () => !(apiFehlt() && Date.now() - t0 < 3000) && !entscheidungOffen();
      if (bereit()) {
        show();
        return;
      }
      const pruefer = window.setInterval(() => {
        if (bereit()) {
          window.clearInterval(pruefer);
          window.setTimeout(show, 600);
        }
      }, 500);
    };

    /* Ein Ausloeser reicht; der erste gewinnt. */
    const ausloesen = () => {
      if (ausgeloest) return;
      ausgeloest = true;
      window.clearInterval(uhr);
      zeigeWennFrei();
    };

    if (force) {
      /* Testschalter ?amra-popup=1: sofort, ohne Sperren und ohne Consent-Wartezeit. */
      window.setTimeout(show, 300);
    } else if (!designMode && !unterdrueckt()) {
      if (perZeit) {
        const pruefeZeit = () => {
          merkeZeit();
          if (besuchszeit() >= delay * 1000) ausloesen();
        };
        uhr = window.setInterval(pruefeZeit, 1000);
        pruefeZeit();
      }
      /* Exit-Intent nur mit Mauszeiger: Zeiger verlaesst das Fenster nach
         oben (Adressleiste, Tabs, Schliessen), fruehestens nach 4 s. Touch
         hat keinen Zeiger — dort greifen Zeit und Scrolltiefe. */
      if (perExit) {
        document.addEventListener('mouseout', (e) => {
          if (!e.relatedTarget && e.clientY <= 0 && besuchszeit() >= 4000) ausloesen();
        });
      }
      /* Scrolltiefe im jeweils gescrollten Bereich (Dokument, Horizons
         .page-wrapper oder das Startseiten-Deck) — capture faengt alle. */
      if (scrollPct > 0) {
        document.addEventListener(
          'scroll',
          (e) => {
            const t = e.target === document ? document.scrollingElement : e.target;
            if (!t || !t.scrollHeight) return;
            const weg = t.scrollHeight - t.clientHeight;
            if (weg < 200) return;
            if ((t.scrollTop / weg) * 100 >= scrollPct) ausloesen();
          },
          { capture: true, passive: true }
        );
      }
    }

    root.querySelectorAll('[data-amra-popup-close]').forEach((btn) => {
      btn.addEventListener('click', hide);
    });

    root.querySelectorAll('[data-amra-answer]').forEach((btn) => {
      btn.addEventListener('click', () => {
        answer = btn.dataset.amraAnswer;
        goto(2);
      });
    });

    const form = root.querySelector('[data-amra-popup-form]');
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const email = form.querySelector('input[type="email"]').value.trim();
        const vorname = (form.querySelector('#amra-popup-first-name') || { value: '' }).value.trim();
        const error = root.querySelector('[data-amra-popup-error]');
        error.hidden = true;
        const company = root.dataset.company;
        const list = root.dataset.list;
        if (!company || !list) {
          error.textContent = form.dataset.textUnconfigured;
          error.hidden = false;
          return;
        }
        try {
          const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            // Revision NICHT willkuerlich zurueckdrehen: erst ab 2025 nimmt dieser
            // Endpunkt 'subscriptions' im Profil an. Mit 2024-10-15 antwortet er 400,
            // und jede Anmeldung scheitert still.
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'AMRA Newsletter Popup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        first_name: vorname,
                        // Standardfeld locale (BCP 47, z. B. de-DE) fuer Segmente/Vorlagen;
                        // "language" als schlichte Property fuer den Welcome-Split, weil
                        // Klaviyos abgeleitetes "Locale: Language" asynchron entsteht.
                        locale: (root.dataset.lang || 'de') + '-' + (root.dataset.country || 'DE'),
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                        properties: Object.assign(
                          {
                            language: root.dataset.lang || 'de',
                            signup_source: 'popup',
                          },
                          // Anlass nur setzen, wenn gewaehlt — ein leerer Wert wuerde
                          // Noels Rueckfallblock (Mail 5) aushebeln.
                          answer ? { occasion: answer } : {}
                        ),
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: list } } },
              },
            }),
          });
          if (!res.ok && res.status !== 202) throw new Error('subscribe failed');
          try {
            localStorage.setItem(KEY_DONE, '1');
          } catch (e) {}
          goto(3);
        } catch (e) {
          error.hidden = false;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-product"]) return;
  try {
    
  document.querySelectorAll('[data-amra-product]').forEach((root) => {
    const slides = root.querySelectorAll('[data-amra-slide]');
    const thumbs = root.querySelectorAll('[data-amra-thumb]');
    const show = (index) => {
      slides.forEach((s) => {
        if (s.dataset.amraSlide === String(index)) s.setAttribute('data-amra-current', '');
        else s.removeAttribute('data-amra-current');
      });
      thumbs.forEach((t) => t.classList.toggle('amra-product__thumb--active', t.dataset.amraThumb === String(index)));
    };
    show(0);
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.amraThumb)));

    const modeButtons = root.querySelectorAll('[data-amra-mode]');
    const aboPanel = root.querySelector('[data-amra-abo]');
    const optionsPanel = root.querySelector('.amra-product__options');
    const setMode = (mode) => {
      modeButtons.forEach((b) => {
        const active = b.dataset.amraMode === mode;
        b.classList.toggle('amra-product__mode-option--active', active);
        b.setAttribute('aria-checked', active);
      });
      if (aboPanel) aboPanel.hidden = mode !== 'abo';
      if (optionsPanel) optionsPanel.hidden = mode === 'abo';
      if (mode === 'abo') {
        const freq = root.querySelector('input[name="amra-abo-freq"]:checked');
        if (freq && freq.dataset.perBottle) kopfpreis(freq.dataset.perBottle, true);
      } else {
        const pack = root.querySelector('input[name="amra-pack"]:checked');
        if (pack && pack.dataset.bottle) kopfpreis(pack.dataset.bottle, pack.dataset.discount === 'true');
      }
      const submitBtn = root.querySelector('[data-amra-submit]');
      // Das Feld traegt den Selling Plan an /cart/add. Im Einmalkauf muss es
      // disabled sein, sonst schickt das Formular einen leeren selling_plan mit
      // und Shopify legt den Artikel gar nicht erst in den Warenkorb.
      const planInput = root.querySelector('[data-amra-plan-input]');
      const mengeInput = root.querySelector('[data-amra-quantity]');
      // Der Grundpreis gehoert zum Betrag, der gerade angezeigt wird — beim
      // Umschalten muss er also mitwandern (PAngV).
      const grundEl = root.querySelector('[data-amra-unit-price]');
      if (grundEl) {
        if (mode === 'abo') {
          if (!grundEl.dataset.amraPrev) grundEl.dataset.amraPrev = grundEl.textContent;
          const f = root.querySelector('input[name="amra-abo-freq"]:checked');
          const fallback = root.querySelector('[data-amra-plan-input]');
          const wert = (f && f.dataset.unitPrice) || (fallback && fallback.dataset.amraAboUnit);
          if (wert) grundEl.textContent = wert;
        } else if (grundEl.dataset.amraPrev) {
          grundEl.textContent = grundEl.dataset.amraPrev;
          delete grundEl.dataset.amraPrev;
        }
      }
      if (planInput) {
        if (mode === 'abo') {
          const gewaehlt = root.querySelector('input[name="amra-abo-freq"]:checked');
          planInput.value = gewaehlt ? gewaehlt.value : planInput.dataset.amraFallback || '';
          planInput.disabled = !planInput.value;
          // Das Abo ist eine feste Kistengroesse. Die Paketwahl ist im Abo-Modus
          // ausgeblendet, ihre Menge darf also nicht mitwandern.
          if (mengeInput) {
            if (!mengeInput.dataset.amraPrev) mengeInput.dataset.amraPrev = mengeInput.value;
            mengeInput.value = planInput.dataset.amraBottles || mengeInput.value;
          }
        } else {
          planInput.value = '';
          planInput.disabled = true;
          if (mengeInput && mengeInput.dataset.amraPrev) {
            mengeInput.value = mengeInput.dataset.amraPrev;
            delete mengeInput.dataset.amraPrev;
          }
        }
      }
      if (submitBtn) {
        if (mode === 'abo') {
          if (!submitBtn.dataset.amraPrevHtml) submitBtn.dataset.amraPrevHtml = submitBtn.innerHTML;
          submitBtn.textContent = submitBtn.dataset.amraAboLabel || '';
          submitBtn.disabled = !(planInput && planInput.value);
        } else if (submitBtn.dataset.amraPrevHtml) {
          submitBtn.innerHTML = submitBtn.dataset.amraPrevHtml;
          delete submitBtn.dataset.amraPrevHtml;
          submitBtn.disabled = false;
        }
      }
    };

    // Frequenzwechsel: Preis, Unterzeile und Button nachziehen.
    const aboPreisEl = root.querySelector('[data-amra-abo-price]');
    const aboSubEl = root.querySelector('[data-amra-abo-sub]');
    const aboSubVorlage = aboSubEl ? aboSubEl.dataset.amraTemplate : null;
    root.querySelectorAll('input[name="amra-abo-freq"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        root.querySelectorAll('.amra-product__abo-freq-option').forEach((l) => {
          l.classList.toggle('amra-product__abo-freq-option--active', l.contains(radio) && radio.checked);
        });
        if (aboPreisEl) aboPreisEl.textContent = radio.dataset.price;
        kopfpreis(radio.dataset.perBottle, true);
        if (aboSubEl && aboSubVorlage) {
          aboSubEl.textContent = aboSubVorlage
            .replace('@@PB@@', radio.dataset.perBottle)
            .replace('@@RG@@', aboSubEl.dataset.amraRegular || '');
        }
        const submitBtn2 = root.querySelector('[data-amra-submit]');
        if (submitBtn2 && submitBtn2.dataset.amraAboLabelBase) {
          submitBtn2.dataset.amraAboLabel =
            submitBtn2.dataset.amraAboLabelBase + ' — ' + radio.dataset.price;
          if (!submitBtn2.disabled && root.querySelector('[data-amra-mode="abo"]').getAttribute('aria-checked') === 'true') {
            submitBtn2.textContent = submitBtn2.dataset.amraAboLabel;
          }
        }
        const planInput2 = root.querySelector('[data-amra-plan-input]');
        if (planInput2 && !planInput2.disabled) planInput2.value = radio.value;
        const grundEl = root.querySelector('span[data-amra-unit-price]');
        if (grundEl && radio.dataset.unitPrice) grundEl.textContent = radio.dataset.unitPrice;
        const titelEl = root.querySelector('[data-amra-abo-name]');
        if (titelEl && radio.dataset.titel) titelEl.textContent = radio.dataset.titel;
      });
    });
    modeButtons.forEach((b) => b.addEventListener('click', () => setMode(b.dataset.amraMode)));

    const variantInput = root.querySelector('[data-amra-variant-id]');
    const priceEl = root.querySelector('[data-amra-price]');
    const priceEffEl = root.querySelector('[data-amra-price-eff]');
    const priceAltEl = root.querySelector('[data-amra-price-alt]');
    const kopfpreis = (wert, rabatt) => {
      if (priceEffEl) priceEffEl.textContent = wert;
      if (priceAltEl) priceAltEl.hidden = !rabatt;
    };
    const ctaPriceEl = root.querySelector('[data-amra-cta-price]');
    const unitPriceEl = root.querySelector('[data-amra-unit-price]');
    const submit = root.querySelector('[data-amra-submit]');
    const qtyInput = root.querySelector('[data-amra-quantity]');
    root.querySelectorAll('input[name="amra-pack"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (qtyInput) qtyInput.value = radio.value;
        if (ctaPriceEl) ctaPriceEl.textContent = radio.dataset.total;
        kopfpreis(radio.dataset.bottle, radio.dataset.discount === 'true');
        if (unitPriceEl && radio.dataset.unitPrice) unitPriceEl.textContent = radio.dataset.unitPrice;
      });
    });
    root.querySelectorAll('input[name="amra-variant"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (variantInput) variantInput.value = radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
        if (ctaPriceEl) ctaPriceEl.textContent = radio.dataset.price;
        if (unitPriceEl && radio.dataset.unitPrice) unitPriceEl.textContent = radio.dataset.unitPrice;
        if (submit) submit.disabled = radio.dataset.available !== 'true';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      });
    });

    const form = root.querySelector('[data-amra-form]');
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const btn = root.querySelector('[data-amra-submit]');
        const error = root.querySelector('[data-amra-error]');
        const live = root.querySelector('[data-amra-live]');
        if (error) error.hidden = true;
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = '0.7';
        }
        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Fehler');
          if (live) live.textContent = 'Zum Warenkorb hinzugefügt';
          document.dispatchEvent(new CustomEvent('amra:cart:refresh', { detail: { open: true } }));
        } catch (err) {
          if (error) {
            error.textContent = err.message || 'Das hat nicht geklappt — bitte versuche es erneut.';
            error.hidden = false;
          }
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.style.opacity = '';
          }
        }
      });
    }

    // Pre-Order-Dialog (Handoff 3): Zeile oeffnet, X/Backdrop schliessen.
    const preorderOpen = root.querySelector('[data-amra-preorder-open]');
    const preorderDialog = document.querySelector('[data-amra-preorder-dialog]');
    if (preorderOpen && preorderDialog) {
      preorderOpen.addEventListener('click', () => preorderDialog.showModal());
      preorderDialog.addEventListener('click', (e) => {
        if (e.target === preorderDialog) preorderDialog.close();
      });
      const preorderClose = preorderDialog.querySelector('[data-amra-preorder-close]');
      if (preorderClose) preorderClose.addEventListener('click', () => preorderDialog.close());
    }

    // v2: "Mehr lesen" fuer die eingeklappte Beschreibung — der Umschalter
    // erscheint nur, wenn der Klapptext wirklich etwas abschneidet (mobil).
    const desc = root.querySelector('[data-amra-desc]');
    if (desc) {
      const descText = desc.querySelector('[data-amra-desc-text]');
      const descToggle = desc.querySelector('[data-amra-desc-toggle]');
      const descPruefe = () => {
        if (desc.classList.contains('amra-product__desc--offen')) return;
        descToggle.hidden = descText.scrollHeight <= descText.clientHeight + 1;
      };
      descToggle.addEventListener('click', () => {
        const offen = desc.classList.toggle('amra-product__desc--offen');
        descToggle.setAttribute('aria-expanded', offen ? 'true' : 'false');
        descToggle.textContent = offen ? descToggle.dataset.textLess : descToggle.dataset.textMore;
      });
      descPruefe();
      window.addEventListener('resize', descPruefe, { passive: true });
    }

    // v2: Sticky-CTA mobil — taucht auf, sobald der echte CTA nach oben aus
    // dem Bild ist, und spiegelt dessen Beschriftung (Paket-/Abo-Wechsel).
    const sticky = root.querySelector('[data-amra-sticky]');
    const hauptCta = root.querySelector('[data-amra-submit]');
    if (sticky && hauptCta && 'IntersectionObserver' in window) {
      const stickyBtn = sticky.querySelector('[data-amra-sticky-submit]');
      const spiegel = () => { stickyBtn.textContent = hauptCta.textContent; };
      new MutationObserver(spiegel).observe(hauptCta, { childList: true, subtree: true, characterData: true });
      new IntersectionObserver((eintraege) => {
        const e = eintraege[0];
        const oben = e.boundingClientRect.bottom < 0;
        sticky.classList.toggle('amra-product__sticky--sichtbar', !e.isIntersecting && oben);
      }, { threshold: 0 }).observe(hauptCta);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Seite 2+ aus derselben Judge.me-API, gerendert im selben Markup wie Seite 1. */
  (() => {
    const API = 'https://api.judge.me/reviews/reviews_for_widget';

    /* Judge.me liefert Titel und Text bereits HTML-escaped. Erst dekodieren,
       dann selbst escapen — sonst steht "&amp;" sichtbar in der Bewertung. */
    const decode = (s) => {
      const el = document.createElement('textarea');
      el.innerHTML = String(s == null ? '' : s);
      return el.value;
    };

    const esc = (s) =>
      String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const STAR =
      '<path d="M6 1l1.55 3.14 3.45.5-2.5 2.44.59 3.42L6 8.88 2.91 10.5l.59-3.42L1 4.64l3.45-.5Z" fill="currentColor"/>';

    const stars = (score) => {
      let out = '';
      for (let i = 1; i <= 5; i++) {
        out +=
          '<svg class="amra-reviews__star' + (i > score ? ' amra-reviews__star--empty' : '') +
          '" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true">' + STAR + '</svg>';
      }
      return '<span class="amra-reviews__item-stars" role="img" aria-label="' + score +
        ' von 5 Sternen">' + out + '</span>';
    };

    /* body kommt als Klartext aus der API — genau einmal escapen, sonst stehen
       Entities wie &amp; sichtbar in der Bewertung. */
    const review = (r, translations, lang, multilingual) => {
      let title = r.title;
      let body = r.body;
      const tr = multilingual && lang !== r.language &&
        translations && translations[r.uuid] && translations[r.uuid][lang];
      if (tr) {
        title = tr.title || title;
        body = tr.body || body;
      }
      const score = Math.round(Number(r.rating) || 0);
      const pics = (r.pictures_urls || []).slice(0, 3).map((p) => {
        const url = typeof p === 'string' ? p : p.compact || p.original || p.huge;
        return '<img class="amra-reviews__item-pic" src="' + esc(url) +
          '" alt="" loading="lazy" width="88" height="88">';
      }).join('');

      return '<article class="amra-reviews__item">' +
        '<div class="amra-reviews__item-head">' +
          '<span class="amra-reviews__name amra-caps">' + esc(decode(r.reviewer_name)) + '</span>' +
          stars(score) +
        '</div>' +
        (title ? '<p class="amra-reviews__item-title">' + esc(decode(title)) + '</p>' : '') +
        (body ? '<p class="amra-reviews__item-text">' + esc(decode(body)).replace(/\n/g, '<br>') + '</p>' : '') +
        (pics ? '<div class="amra-reviews__item-pics">' + pics + '</div>' : '') +
      '</article>';
    };

    const pageButton = (page, label, current, aria) =>
      '<button type="button" class="amra-reviews__page' +
      (page === current ? ' amra-reviews__page--current' : '') +
      (aria ? ' amra-reviews__page--arrow' : '') + '" data-page="' + page + '"' +
      (aria ? ' aria-label="' + aria + '"' : '') +
      (page === current ? ' aria-current="page"' : '') + '>' + label + '</button>';

    const paginate = (current, total) => {
      if (total <= 1) return '';
      const start = Math.max(1, Math.min(current - 1, total - 2));
      let out = '';
      if (current > 1) {
        out += pageButton(1, '&laquo;', current, 'Erste Seite');
        out += pageButton(current - 1, '&lsaquo;', current, 'Vorherige Seite');
      }
      for (let p = start; p < start + 3 && p <= total; p++) out += pageButton(p, p, current, null);
      if (current < total) {
        out += pageButton(current + 1, '&rsaquo;', current, 'Nächste Seite');
        out += pageButton(total, '&raquo;', current, 'Letzte Seite');
      }
      return out;
    };

    document.querySelectorAll('[data-amra-reviews]').forEach((root) => {
      const grid = root.querySelector('[data-amra-reviews-grid]');
      const nav = root.querySelector('[data-amra-reviews-paginate]');
      const shop = root.dataset.shop;
      const productId = root.dataset.productId;
      if (!grid || !nav || !shop || !productId) return;

      const lang = root.dataset.lang || 'de';
      const multilingual = root.dataset.multilingual === 'true';
      let busy = false;

      const load = async (page) => {
        if (busy) return;
        busy = true;
        root.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(API);
          url.searchParams.set('url', shop);
          url.searchParams.set('shop_domain', shop);
          url.searchParams.set('platform', 'shopify');
          url.searchParams.set('product_id', productId);
          url.searchParams.set('per_page', root.dataset.perPage || '5');
          url.searchParams.set('page', String(page));

          const res = await fetch(url.toString(), { credentials: 'omit' });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const data = await res.json();
          const list = data.reviews || [];
          if (!list.length) throw new Error('leer');

          grid.innerHTML = list.map((r) => review(r, data.review_translations, lang, multilingual)).join('');
          const p = data.pagination || {};
          nav.innerHTML = paginate(p.current_page || page, p.total_pages || 1);

          /* Horizon scrollt in .page-wrapper, nicht im window — scrollIntoView
             findet den richtigen Container selbst. Der Abstand zum Header
             kommt aus scroll-margin-top. */
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
          console.warn('[AMRA] Bewertungsseite nicht geladen:', err.message);
        } finally {
          busy = false;
          root.removeAttribute('aria-busy');
        }
      };

      nav.addEventListener('click', (event) => {
        const btn = event.target.closest('.amra-reviews__page');
        if (!btn || btn.classList.contains('amra-reviews__page--current')) return;
        const page = parseInt(btn.dataset.page, 10);
        if (page) load(page);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-screens"] && !Shopify.designMode) return;
  try {
    
  // Weiche Kante am Deck-Ende, beide Richtungen (Ansage Michi):
  // Sobald der letzte Screen eingerastet ist, wird das Snapping geloest —
  // der Uebergang in die Seite (und zurueck hinein) laeuft dann frei, ohne
  // dass "mandatory" den Schwung abwuergt. Beim Hochscrollen bleibt der
  // Lauf frei, solange die Geste laeuft; erst nach kurzer Ruhe rastet das
  // Snapping wieder ein und zieht auf den naechsten Screen. Zwischen den
  // oberen Screens bleibt alles reines CSS wie gehabt.
  (() => {
    const deck = document.querySelector('[data-amra-deck]');
    if (!deck) return;
    if (deck.querySelectorAll('.amra-deck__item').length < 2) return;

    let geloest = false;
    let ruheTimer = null;
    let letzterTop = deck.scrollTop;

    const pruefe = () => {
      const top = deck.scrollTop;
      const kante = deck.scrollHeight - deck.clientHeight;
      // Nur beim Ankommen von oben loesen. Beim Verlassen nach oben (Rueckweg
      // vom Footer) bleibt der Magnet scharf — sonst lief die erste Geste
      // frei, und iOS rastete danach nicht mehr ein (Michi 05.09.).
      const abwaerts = top >= letzterTop;
      letzterTop = top;
      if (!geloest && abwaerts && top >= kante - 2) {
        geloest = true;
        deck.style.scrollSnapType = 'none';
        // Exakt an die Kante: iOS reicht eine Wischgeste nur dann an die Seite
        // weiter, wenn der innere Scroller beim Aufsetzen wirklich am Ende
        // steht. Bleibt er 1-2 px davor stehen (das Loesen des Snappings kann
        // die Snap-Animation abschneiden), scrollt iOS erst die 2 px, bounct
        // und die Seite bewegt sich nicht (Michi, iPhone 14.09.).
        if (kante - top > 0.5) deck.scrollTop = kante;
        return;
      }
      if (geloest && top < kante - 2) {
        clearTimeout(ruheTimer);
        ruheTimer = setTimeout(() => {
          geloest = false;
          deck.style.scrollSnapType = '';
        }, 140);
      }
    };

    deck.addEventListener('scroll', pruefe, { passive: true });
    pruefe();
    // Sicherheitsnetz fuer dieselbe iOS-Eigenheit: beim Aufsetzen des Fingers
    // knapp vor der Kante das Deck buendig stellen, bevor iOS die Geste bindet.
    deck.addEventListener('touchstart', () => {
      const kante = deck.scrollHeight - deck.clientHeight;
      const top = deck.scrollTop;
      if (kante - top > 0.5 && kante - top <= 3) deck.scrollTop = kante;
    }, { passive: true });

    // Routing zwischen den zwei Scrollern. Zwei beobachtete Fehlbilder:
    // (1) iOS-Back/BFCache stellt die Seitenposition wieder her, das Deck
    //     steht intern aber auf Screen 1 — abgeschnittener Hero ueber dem
    //     Seiteninhalt (Recording 24.08.).
    // (2) Desktop, Hochscrollen vom Footer: sobald das Deck angeschnitten
    //     sichtbar wird, faengt das Rad dessen INNEN-Scroll — Inhalt rutscht
    //     im Ausschnitt (Screenshot 25.08.).
    // Regel: Solange das Deck nicht buendig im Viewport steht, ist sein
    // Innen-Scroll gesperrt (steht am Ende); Gesten laufen dann automatisch
    // ueber die Seite. Steht es buendig, uebernimmt wieder der Magnet.
    let gesperrt = false;
    const route = () => {
      const oben = deck.getBoundingClientRect().top;
      const kante = deck.scrollHeight - deck.clientHeight;
      if (oben < -2) {
        if (!gesperrt) {
          gesperrt = true;
          deck.style.overflowY = 'hidden';
        }
        if (deck.scrollTop < kante - 1) deck.scrollTop = kante;
      } else if (gesperrt) {
        gesperrt = false;
        // Zurueck am Deck (steht buendig auf dem letzten Screen): Loeser
        // zuruecksetzen, Magnet scharf, Scroller frisch aufsetzen.
        clearTimeout(ruheTimer);
        geloest = false;
        letzterTop = deck.scrollTop;
        deck.style.scrollSnapType = '';
        deck.style.overflowY = '';
        void deck.offsetHeight;
      }
    };

    document.addEventListener('scroll', (e) => {
      if (e.target === deck) return;
      route();
    }, { capture: true, passive: true });
    window.addEventListener('pageshow', () => setTimeout(route, 60));
    setTimeout(route, 60);

    // Diskretes Mausrad (Windows/Linux-Maus, Rastung = ein Sprung von 100 px):
    // Chrome zieht mit mandatory-Snap pro Rastung hart einen Screen weiter,
    // mit seiner eigenen kurzen Animation — "extrem hart" (Surface, 11.09.).
    // Solche Rastungen fangen wir ab und gleiten selbst in 650 ms (ease-out)
    // auf den naechsten Screen; waehrenddessen und 150 ms danach werden
    // weitere Rad-Ereignisse geschluckt (eine Rastung = ein Screen).
    // Trackpads bleiben unberuehrt: ihre Gesten beginnen mit kleinen,
    // meist gebrochenen Deltas, und alles mitten in einer laufenden Geste
    // (< 120 ms seit dem letzten Ereignis) geht weiter an das CSS-Snapping.
    let gleitet = false;
    let gleitAbbruch = false;
    let sperreBis = 0;
    let letztesRad = 0;
    const items = [...deck.querySelectorAll('.amra-deck__item')];

    // Snapping wieder scharf — ausser am letzten Screen, wo der Kanten-Loeser
    // (pruefe) es bewusst geloest haelt.
    const snapScharf = () => {
      if (!geloest) deck.style.scrollSnapType = '';
    };

    const gleiteZu = (ziel) => {
      const start = deck.scrollTop;
      const weg = ziel - start;
      if (!weg) {
        snapScharf();
        return;
      }
      const t0 = performance.now();
      const dauer = 650;
      gleitet = true;
      gleitAbbruch = false;
      deck.style.scrollSnapType = 'none';
      const schritt = (t) => {
        if (gleitAbbruch) {
          gleitet = false;
          gleitAbbruch = false;
          return;
        }
        const p = Math.min(1, (t - t0) / dauer);
        deck.scrollTop = start + weg * (1 - Math.pow(1 - p, 3));
        if (p < 1) {
          requestAnimationFrame(schritt);
          return;
        }
        deck.scrollTop = ziel;
        gleitet = false;
        sperreBis = performance.now() + 150;
        // Kanten-Loeser (pruefe) hat waehrend der Fahrt mitgezaehlt: am
        // letzten Screen bleibt das Snapping geloest, sonst wieder scharf.
        snapScharf();
      };
      requestAnimationFrame(schritt);
    };

    deck.addEventListener('wheel', (e) => {
      const jetzt = performance.now();
      if (gleitet || jetzt < sperreBis) {
        e.preventDefault();
        return;
      }
      const rastung = e.deltaMode === 1 || (e.deltaMode === 0 && Number.isInteger(e.deltaY) && Math.abs(e.deltaY) >= 40);
      const neueGeste = jetzt - letztesRad > 120;
      letztesRad = jetzt;
      if (!rastung || !neueGeste || gesperrt || items.length < 2) return;
      const top = deck.scrollTop;
      let idx = 0;
      items.forEach((it, i) => {
        if (Math.abs(it.offsetTop - top) < Math.abs(items[idx].offsetTop - top)) idx = i;
      });
      // Nur aus eingerasteter Lage und nur zwischen den Screens; an den
      // Raendern uebernimmt der Browser (Uebergabe an die Seite).
      if (Math.abs(items[idx].offsetTop - top) > 4) return;
      const zielIdx = idx + (e.deltaY > 0 ? 1 : -1);
      if (zielIdx < 0 || zielIdx >= items.length) return;
      e.preventDefault();
      gleiteZu(items[zielIdx].offsetTop);
    }, { passive: false });

    // Finger oder Touchpad — NUR WINDOWS. Dort zieht mandatory-Snap beim
    // Loslassen eines kurzen Wischs erst hart auf den Ausgangs-Screen zurueck
    // (Mikes Aufnahme 11.09.: 500 px Wisch, Ruecksprung in 70 ms, dann erst
    // weiter). Deshalb ist das Snapping fuer die Dauer der Geste AUS: der
    // Wisch folgt frei dem Finger bzw. dem Touchpad, nach dem Nachlauf (90 ms
    // Scroll-Ruhe) waehlen wir das Ziel — ab 24 px Auslenkung der naechste
    // Screen in Wischrichtung, sonst zurueck — und gleiten in 650 ms dorthin.
    // Ein Screen pro Geste; ein neuer Finger bricht eine laufende Fahrt ab.
    // Mac-Trackpad und iPhone fuehlen sich laut Michi gut an und bleiben
    // deshalb beim reinen CSS-Snapping.
    const aufWindows = (navigator.userAgentData && navigator.userAgentData.platform === 'Windows') || /Windows NT/.test(navigator.userAgent);
    let geste = null;
    let ruheStopp = null;
    let radEnde = null;
    const naechsterIdx = (top) => {
      let idx = 0;
      items.forEach((it, i) => {
        if (Math.abs(it.offsetTop - top) < Math.abs(items[idx].offsetTop - top)) idx = i;
      });
      return idx;
    };
    // Ruft cb nach 90 ms ohne Deck-Scroll (spaetestens nach 1500 ms); liefert
    // eine Stopp-Funktion.
    const aufRuhe = (cb) => {
      let timer = null;
      let notaus = null;
      const stopp = () => {
        clearTimeout(timer);
        clearTimeout(notaus);
        deck.removeEventListener('scroll', neu);
      };
      const fertig = () => {
        stopp();
        cb();
      };
      const neu = () => {
        clearTimeout(timer);
        timer = setTimeout(fertig, 90);
      };
      deck.addEventListener('scroll', neu, { passive: true });
      neu();
      notaus = setTimeout(fertig, 1500);
      return stopp;
    };
    const gesteStart = () => {
      if (gesperrt) return;
      if (geste && geste.wartet) {
        // Naechste Geste kommt, bevor die vorige zu Ende gerechnet ist.
        ruheStopp();
        geste = null;
      }
      if (geste) return;
      if (gleitet) gleitAbbruch = true;
      const top = deck.scrollTop;
      geste = { startIdx: naechsterIdx(top), startTop: top, weg: 0, wartet: false };
      deck.style.scrollSnapType = 'none';
    };
    const gesteEnde = () => {
      const g = geste;
      if (!g || g.wartet) return;
      g.wartet = true;
      ruheStopp = aufRuhe(() => {
        geste = null;
        if (gesperrt) {
          snapScharf();
          return;
        }
        const h = deck.clientHeight;
        const top = deck.scrollTop;
        let ziel = g.startIdx;
        if (Math.abs(g.weg) >= 24) {
          const schritte = Math.max(1, Math.round(Math.abs(top - g.startTop) / h));
          ziel = g.startIdx + (g.weg > 0 ? 1 : -1) * schritte;
        }
        ziel = Math.max(0, Math.min(items.length - 1, ziel));
        gleiteZu(items[ziel].offsetTop);
      });
    };
    if (aufWindows) {
      deck.addEventListener('scroll', () => {
        if (!geste) return;
        const d = deck.scrollTop - geste.startTop;
        if (Math.abs(d) > Math.abs(geste.weg)) geste.weg = d;
      }, { passive: true });
      deck.addEventListener('touchstart', gesteStart, { passive: true });
      deck.addEventListener('touchend', gesteEnde, { passive: true });
      deck.addEventListener('touchcancel', gesteEnde, { passive: true });
      // Touchpad: Geste beginnt mit dem ersten Rad-Ereignis und endet nach
      // 150 ms ohne weiteres (Nachlauf zaehlt zur Geste). Rastungen eines
      // Mausrads sind oben schon abgefangen (defaultPrevented).
      deck.addEventListener('wheel', (e) => {
        if (e.defaultPrevented || gleitet) return;
        if (!geste) gesteStart();
        clearTimeout(radEnde);
        radEnde = setTimeout(gesteEnde, 150);
      }, { passive: true });
    }

    // Screen-Videos: nur im Sichtfeld spielen. Browser pausieren
    // Offscreen-Videos ohnehin, nehmen sie aber nicht zuverlaessig
    // wieder auf — der Observer garantiert beides. root = Viewport:
    // das Clipping durch das Deck rechnet der Observer mit ein.
    const videos = deck.querySelectorAll('.amra-deck__video');
    if (videos.length && 'IntersectionObserver' in window) {
      const videoBeobachter = new IntersectionObserver((eintraege) => {
        eintraege.forEach((eintrag) => {
          const video = eintrag.target;
          if (eintrag.isIntersecting) {
            const versuch = video.play();
            if (versuch) versuch.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      videos.forEach((video) => videoBeobachter.observe(video));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-support"] && !Shopify.designMode) return;
  try {
    
  /* Nur zeigen, was zum gewählten Thema gehört. */
  document.querySelectorAll('[data-amra-support]').forEach((form) => {
    const orderField = form.querySelector('[data-amra-order]');
    const returnField = form.querySelector('[data-amra-return]');
    const topics = form.querySelectorAll('input[name="contact[Thema]"]');
    if (!topics.length) return;

    const sync = () => {
      const active = [...topics].find((t) => t.checked);
      if (!active) return;
      if (orderField) orderField.hidden = active.dataset.needsOrder !== 'true';
      if (returnField) returnField.hidden = active.dataset.isReturn !== 'true';
    };

    topics.forEach((t) => t.addEventListener('change', sync));
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-ugc"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.amra-ugc').forEach((root) => {
    const dialog = root.querySelector('[data-amra-ugc-dialog]');
    if (!dialog) return;
    const body = dialog.querySelector('[data-amra-ugc-body]');
    const title = dialog.querySelector('[data-amra-ugc-title]');
    root.querySelectorAll('[data-amra-ugc]').forEach((tile) => {
      tile.addEventListener('click', () => {
        const img = tile.querySelector('.amra-ugc__image');
        const handle = tile.querySelector('.amra-ugc__handle');
        body.innerHTML = '';
        if (img) {
          const clone = img.cloneNode(true);
          clone.removeAttribute('style');
          body.appendChild(clone);
        }
        title.textContent = handle ? handle.textContent : '';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-amra-ugc-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
